import Http from '@/services/http';
import {
  NetworkStatusHistoryResponse,
  NetworkStatusHistoryRequest,
  NetworkStatusListFilterRequest,
  NetworkStatusListFilterResponse,
} from 'sigma-mappings';

const url = {
  networkStatusList: '/StatusRede/listagem',
  networkStatusHistoryList: '/StatusRede/listagem/historico',
  download: {
    xlsx: '/StatusRede/listagem/exportar/excel',
    pdf: '/StatusRede/listagem/exportar/pdf',
  },
  resetSensors: installationId => `/StatusRede/resetar-sensores/${installationId}`,
};

export default {
  getList(params) {
    const http = new Http();
    let apiModel;
    if (params) {
      apiModel = new NetworkStatusListFilterRequest(params);
    }
    return http
      .post(url.networkStatusList, apiModel)
      .then(({ data }) => new NetworkStatusListFilterResponse(data));
  },
  /** Obtém a lista de histórico de status de rede.
   * @param filter.companiesIds ids das empresas
   * @param filter.regionalsIds ids das regionais
   * @param filter.installationsIds ids das instalações
   * @param filter.assetsIds ids dos ativos
   * @param filter.modulesIds ids dos modulos
   * @param filter.moduleStatus status do modulo
   * @param filter.networkStatus status da rede
   * @param filter.moduleSelfDiagnosisStatuss condições de autodiagnósticos
   * @param filter.company empresa
   * @param filter.installation instalação
   * @param filter.ip ip
   * @param filter.address endereço
   * @param filter.period periodo filtrado (Não utilizado se utilizar periodo final e inicial)
   * @param filter.initialDate periodo inicial
   * @param filter.finalDate periodo final
   * @param filter.assetSearchTerm termo busca ativo
  */
  getHistoryList(params) {
    const http = new Http();
    const mappedParams = new NetworkStatusHistoryRequest(params);
    return http
      .post(url.networkStatusHistoryList, mappedParams)
      .then(({ data }) => new NetworkStatusHistoryResponse(data));
  },
  /** Obtém dados do relatório de acordo com o tipoe os filtros
     * @param type tipo do download ('pdf' ou 'xlsx')
     * @param filter.companiesIds ids das empresas
     * @param filter.regionalsIds ids das regionais
     * @param filter.installationsIds ids das instalações
     * @param filter.assetsIds ids dos ativos
     * @param filter.modulesIds ids dos módulos
     * @param filter.address endereço da rede
     * @param filter.ip ip da rede
     * @param filter.moduleSelfDiagnosisStatuss condições de autodiagnósticos
     * (ModuleSelfDiagnosisStatusType)
     * @param filter.moduleStatus lista dos status de comunicação dos módulos (ModuleStatusType)
     * @param filter.networkStatus lista dos status de comunicação dos modems (NetworkStatusType)
     * @param filter.period periodo filtrado
     * @param filter.initialDate data inicial período filtrado
     * @param filter.finalDate data final período filtrado
     * @param filter.page página atual
     * @param filter.pageSize quantidade de itens da página
     */
  downloadList(type, params) {
    const downloadUrl = url.download[type];
    if (!downloadUrl) {
      throw new Error(`Tipo não suportado para download: ${type}`);
    }

    const http = new Http({
      download: true,
      errorHandling: {
        hideError: (error = {}) => (error.response || {}).status === 400,
      },
    });
    let apiModel;
    if (params) {
      apiModel = new NetworkStatusListFilterRequest(params);
    }
    return http
      .post(downloadUrl, apiModel)
      .then(({ data }) => data);
  },
  resetSensors(installationId) {
    const http = new Http();
    return http
      .delete(url.resetSensors(installationId))
      .then(({ data }) => data);
  },
};
